import { Minor } from "./types"

// Currency is assumed to have 2 decimal places
export const MINOR_PER_MAJOR = 100

export const toMinor = (value: number | string | null | undefined): Minor => {
	const parsed = Number(value)
	return Number.isFinite(parsed) ? Math.round(parsed * MINOR_PER_MAJOR) : 0
}

export const toMajor = (value: Minor): number => value / MINOR_PER_MAJOR

export const percentOf = (amount: Minor, percent: number): Minor => Math.round((amount * percent) / 100)

// Split `total` across `weights` proportionally; the shares always add up to exactly `total`
// (largest remainder method), so no cent is lost or invented.
export const allocate = (total: Minor, weights: Minor[]): Minor[] => {
	const weightSum = weights.reduce((sum, weight) => sum + Math.max(weight, 0), 0)
	if (total <= 0 || weightSum <= 0) return weights.map(() => 0)
	const exact = weights.map((weight) => (total * Math.max(weight, 0)) / weightSum)
	const shares = exact.map(Math.floor)
	let remainder = total - shares.reduce((sum, share) => sum + share, 0)
	const order = exact
		.map((value, index) => ({ index, fraction: value - Math.floor(value) }))
		.sort((a, b) => b.fraction - a.fraction || a.index - b.index)
	for (const { index } of order) {
		if (remainder <= 0) break
		shares[index] += 1
		remainder -= 1
	}
	return shares
}
